import Link from 'next/link';

import {
  useMediaQuery,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
  colors,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { SectionHeader, IconAlternate } from '@/src/components/molecules';

import SectionDynamic from './SectionDynamic';

const useStyles = makeStyles(theme => ({
  listItemAvatar: {
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  shape: {
    background: theme.palette.alternate.main,
    borderBottomRightRadius: '100%',
  },
}));

export default function Faq(props) {
  const { className, section, title, subtitle, cta, href, questions, refElem, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={clsx('solutions-faq__section', section === 'alternate' ? classes.shape : '')}>
      <SectionDynamic type={section} className={clsx(classes.sectionNoPaddingTop)}>
        <div className={className} ref={refElem} {...rest}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Grid container spacing={isMd ? 4 : 2}>
                {questions.map((question, index) => (
                  <Grid item xs={12} sm={6} md={4} key={question.title || index.toString()}>
                    <ListItem disableGutters data-aos="fade-up">
                      <ListItemAvatar className={classes.listItemAvatar}>
                        <IconAlternate
                          size="small"
                          shape="circle"
                          fontIconClass="fas fa-question"
                          color={colors.amber}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={question.title}
                        secondary={question.text}
                        primaryTypographyProps={{
                          variant: 'h6',
                          component: 'div',
                        }}
                        secondaryTypographyProps={{
                          variant: 'subtitle1',
                        }}
                      />
                    </ListItem>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <SectionHeader
                title={title}
                subtitle={subtitle}
                align="center"
                ctaGroup={[
                  <Link href={href || '/'} passHref key="faqCta">
                    <Button
                      color="primary"
                      variant="contained"
                      size="large"
                      component="a"
                      aria-label={cta}>
                      {cta}
                    </Button>
                  </Link>,
                ]}
                disableGutter
                data-aos="fade-up"
              />
            </Grid>
          </Grid>
        </div>
      </SectionDynamic>
    </div>
  );
}

Faq.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  cta: PropTypes.string,
  href: PropTypes.string,
  questions: PropTypes.array.isRequired,
  refElem: PropTypes.any,
};
